import { createContext, useContext } from 'react'

/**
 * WHO IS READING, when it is not the agent's owner — owner, 2026-10-17: a friend the agent is
 * shared with reads its conversation in their own app (friends/SharedAgentPanel, on the stage).
 *
 * Clean View was written for one reader, the owner, so a plain `user` block is "you". In the
 * friend's view it is not: it is the person who shared the agent (or the friend themselves when
 * the share lets them speak AS that person — which is the point of that mode). And a
 * `<friend-msg>` is "you" only when its address is the reader's own.
 *
 * A context rather than props because the reading happens in `Msg`, three components down,
 * and only one screen sets it. Null everywhere else, which is the owner's view, unchanged.
 */
export type SharedViewer = {
  /** The reader's own address, to recognise their friend messages. */
  selfEmail: string | null
  /** The reader's own name, for the letter on their messages. */
  selfLabel: string
  /** Whose words a plain message is: the person who shared the agent. */
  ownerLabel: string
}

export const SharedViewContext = createContext<SharedViewer | null>(null)

export const useSharedViewer = (): SharedViewer | null => useContext(SharedViewContext)
